var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"yj-fade-in"}},[(_vm.visible)?_c('div',{staticClass:"yj-backtop",style:({
        'right': _vm.styleRight,
        'bottom': _vm.styleBottom
      }),on:{"click":function($event){$event.stopPropagation();return _vm.handleClick($event)}}},[_vm._t("default",[_c('yj-icon',{attrs:{"name":"caret-top"}})])],2):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/backtop/src/backtop.vue